import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "device-recording-widget",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = { class: "widget-content" }
const _hoisted_3 = { class: "widget-icon" }
const _hoisted_4 = { class: "widget-text" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AIAssistantDeviceRecordingWidget',
  props: {
    visible: { type: Boolean }
  },
  setup(__props: any) {

/**
 * AIAssistantDeviceRecordingWidget.vue
 *
 * Floating widget that appears when a "recording" webhook is received
 * while the state machine is in "device_selection" or "idle".
 *
 * This notifies the user that recording has started on their mobile device
 * (e.g., after scanning the QR code).
 */


return (_ctx: any,_cache: any) => {
  const _component_w_icon = _resolveComponent("w-icon")!
  const _component_w_text = _resolveComponent("w-text")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-up" }, {
    default: _withCtx(() => [
      (__props.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "recording-pulse" }, null, -1)),
                _createVNode(_component_w_icon, {
                  name: "microphone",
                  size: "medium",
                  color: "#fff"
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_w_text, {
                  type: "bodyEmphasis",
                  class: "widget-title"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Gravando no celular ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_w_text, {
                  type: "caption",
                  class: "widget-subtitle"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" A gravação está em andamento no seu dispositivo móvel. ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})